import { createAsyncThunk } from "@reduxjs/toolkit";

import { type AsyncThunkCreator } from "../../../index";
import { fetchTrainee } from "../../trainee/actions";
import { TRAINEE_PROGRAM_REDUCER_NAME } from "../types";

type Payload = {
  programId: string;
  traineeId: string;
  keepOldWorkoutsWithoutStatus: boolean;
};

export const archiveTraineeProgram = createAsyncThunk<void, Payload, AsyncThunkCreator<string>>(
  `${TRAINEE_PROGRAM_REDUCER_NAME}/archiveTraineeProgram`,
  async (payload, { dispatch, extra: { traineeApi, analytics } }) => {
    if (!traineeApi) {
      throw new Error("traineeApi is not defined");
    }

    analytics.track("archive_trainee_program");

    await traineeApi.post("/archive-trainee-program", payload);

    // The service clears trainee.activeTrainingProgramId on its side, so the local
    // profile has to be refetched - otherwise the archived program stays on screen
    // until a manual page reload. Same as toggleProgramAccess does.
    await dispatch(fetchTrainee({ id: payload.traineeId, refetch: true }));
  },
);
